import { parsePhoneNumber } from 'libphonenumber-js'
import { tracking } from '@bark/bark-core';

export function CallBuyerModal() {
	let Bark = (window.Bark = window.Bark || {});

	Bark.callBuyer = {
		called: false,
		projectId: null,
		projectResponseId: null,
		successCallback: null,

		/**
		 * Listen for specific modal events
		 */
		initModals() {
			$('#barkCallBuyerModal').on('hidden.bs.modal', () => {
				// Record if they have called
				let project_id =
					Bark.sellerResponseFlow && Bark.sellerResponseFlow.projectId
						? Bark.sellerResponseFlow.projectId
						: Bark.callBuyer.currentProjectId
						? Bark.callBuyer.currentProjectId
						: 'unknown';
				if (Bark.callBuyer.called) {
					Bark.logEvent('call-buyer', 'called-buyer-manually', 'seller-response-flow');
					tracking(
						'seller-leads-dashboard-&-responses',
						'Call success',
						{
							pagename: window.location.pathname,
							project_id: project_id,
							lead_type: 'project',
						},
					);
					if (typeof Bark.callBuyer.successCallback == 'function') {
						Bark.callBuyer.successCallback();
					}
				} else {
					Bark.logEvent(
						'call-buyer',
						'not-called-buyer-manually',
						'seller-response-flow',
					);
					tracking(
						'seller-leads-dashboard-&-responses',
						'Call cancel',
						{
							pagename: window.location.pathname,
							project_id: project_id,
							lead_type: 'project',
						},
					);
				}
			});

			$('#barkCallBuyerModal #call-buyer-done-button').on('click', () => {
				Bark.callBuyer.called = true;
			});

			return this;
		},

		/**
		 * Registars a callback function to call when this step is complete
		 * @param {function} executable
		 */
		registerSuccessCallback(executable) {
			this.successCallback = executable;
		},

		/**
		 * Resets everything when a new lead is selected
		 * @param buyerName {string} The name of the buyer
		 * @param buyerPhoneNumber {string|null} The buyer's telephone number
		 * @returns {Window.Bark.callBuyer}
		 */
		resetStatus(buyerName, buyerPhoneNumber = '') {
			$('#barkCallBuyerModal .buyer_name').text(buyerName);

			// Close the modal if it is open
			$('#barkCallBuyerModal').modal('hide');

			// set the phone number
			this.setPhoneNumber(buyerPhoneNumber);

			return this;
		},

		/**
		 * Formats and displays the phone number in the modal
		 * @param phoneNumber {string}
		 */
		setPhoneNumber(phoneNumber = null) {
			let phoneNumberToDisplay = '',
				phoneNumberToDial = '#';
			if (phoneNumber && phoneNumber.length) {
				// attempt to parse and format the number
				try {
					const parsedNumber = parsePhoneNumber(
						phoneNumber,
						Bark.ENV.locale.toUpperCase(),
					);
					phoneNumberToDisplay = parsedNumber.formatNational();
					phoneNumberToDial = parsedNumber.getURI();
				} catch (e) {
					bugsnagClient.notify(e);
				}
				// Fallback to provided number
				if (phoneNumberToDisplay === '') {
					phoneNumberToDisplay = phoneNumber;
					// remove any possible extension, or any non-numeric characters
					phoneNumberToDial =
						'tel:' +
						phoneNumberToDisplay
							.toLowerCase()
							.split('x')[0]
							.replace(/[^0-9+]/, '');
				}
			}
			$('#barkCallBuyerModal .call-link').attr('href', phoneNumberToDial);
			$('#barkCallBuyerModal .telephone-number').text(phoneNumberToDisplay);
		},

		/**
		 * Shows the Call Buyer modal
		 */
		showModal() {
			$('#barkCallBuyerModal').modal('show');
			Bark.callBuyer.called = false;
		},
	};

	/**
	 * Load standard BuyerCallModal if BarkConnect not avail
	 */
	if (!window.Bark.BarkConnect) {
		window.Bark.callBuyer.initModals().resetStatus();
	}
}
